<template>
    <div>
        <v-dialog
            max-width="40%"
            v-model="show"
            scrollable
        >
          <v-card>
            <v-card-text class="pb-0 pb-4">
              <v-tabs>
                <v-tab>
                  Policy Management
                </v-tab>
                <v-tab>
                  Employees policies
                </v-tab>
                <v-spacer></v-spacer>
                <v-btn
                  icon
                  @click.prevent="show = false"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-tab-item
                  class="pa-2"
                >
                <v-data-table
                  :headers="policyHeaders"
                  :items="policies"
                  :items-per-page="10"
                  :footer-props="{
                    'items-per-page-options': [10, 20, -1]
                  }"
                  dense
                >
                  <template v-slot:[`item.Actions`]="{ item }">
                    <v-btn icon small
                      color="success"
                      @click.prevent="$emit('showPolicyEditor', item)"
                    >
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn icon small
                      color="red darken-2"
                      @click.prevent="showDeletePolicyDialog(item.Policy_ID)"
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
                </v-tab-item>
                <v-tab-item class="pa-2">
                  <v-card-title>
                    <v-text-field
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                    ></v-text-field>
                    <v-spacer></v-spacer>
                  </v-card-title>
                  <v-data-table
                    :items="policyUsers"
                    :headers="policyUsersHeaders"
                    :items-per-page="10"
                    :search="search"
                    :footer-props="{
                    'items-per-page-options': [10, 20, -1]
                    }"
                    @click:row="clickOnUser"
                    dense
                  >
                    <template
                      v-for="(itm, itmKey) in policyUsersHeaders"
                      v-slot:[`item.${itm.value}`]="{ item }"
                    >
                      <span
                        :key="itmKey"
                        v-if="itm.value === 'Full_Name'"
                      >
                        {{ item[`${itm.value}`] }}
                      </span>
                      <span
                        v-else
                        class="editable-cell"
                        :key="itmKey"
                      >
                        {{ item.All ? ((item.Agreed ? item.Agreed : 0) + '/' + item.All) : '' }}
                      </span>
                    </template>
                  </v-data-table>
                </v-tab-item>
              </v-tabs>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-dialog
          v-model="showPolicyDialog"
          scrollable
          max-width="80%"
        >
          <v-card>
            <EmployeePolicies
              :employee="employeeFullInfo"
              :isTab="false"
              @updatePolicyUserCount="updatePolicyUserCount"
            >
            </EmployeePolicies>
          </v-card>
        </v-dialog>
        <v-dialog
          v-model="deletePolicyDialog"
          max-width="300"
        >
          <v-card>
            <v-card-title>Remove Policy</v-card-title>
            <v-divider></v-divider>
            <v-card-text class="pt-3">
              Are you sure?
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn small color="primary" @click="deletePolicyDialog = false">Cancel</v-btn>
              <v-spacer></v-spacer>
              <v-btn small color="red darken-4 white--text" @click="deletePolicy">Remove</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
  name: 'PolicyLibrary',
  components: {
    EmployeePolicies: () => import('@/components/employee/employee_details_tabs/EmployeePolicies.vue')
  },
  props: {
    value: {
      required: false
    }
  },
  data () {
    return {
      policyHeaders: [
        {
          text: 'ID',
          value: 'Policy_ID',
          divider: true,
          class: 'px-2 text-no-wrap'
        },
        {
          text: 'Title',
          value: 'Policy_Title',
          divider: true,
          class: 'px-2 text-no-wrap'
        },
        {
          text: 'Type',
          value: 'Type_Description',
          divider: true,
          class: 'px-2 text-no-wrap'
        },
        {
          text: 'Actions',
          value: 'Actions',
          class: 'px-2 text-no-wrap',
          width: '20%',
          sortable: false
        }
      ],
      policyUsersHeaders: [
        {
          text: 'Full Name',
          value: 'Full_Name',
          class: 'px-2 text-no-wrap',
          divider: true
        },
        {
          text: 'Agreed',
          value: 'Agreed',
          width: '5%',
          class: 'px-2 text-no-wrap'
        }
      ],
      deletePolicyDialog: false,
      employeeFullInfo: null,
      policyIdToRemove: null,
      search: '',
      currentUser: null,
      currentUsersPolicies: [],
      showPolicyDialog: false
    }
  },
  computed: {
    show: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    user () {
      return this.$store.getters.getUser
    },
    policies () {
      return this.$store.getters.getPolicies
    },
    policyUsers () {
      return this.$store.getters.getPolicyUsers
    }
  },
  mounted () {
    this.getPolicies()
    this.getUsers()
  },
  methods: {
    getPolicies () {
      this.axios.get('/api/employee_policies', {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.$store.dispatch('setPolicies', { policies: res.data })
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    clickOnUser (value) {
      this.currentUser = value
      this.getEmployeeDetails()
    },
    showDeletePolicyDialog (policyId) {
      this.deletePolicyDialog = true
      this.policyIdToRemove = policyId
    },
    getEmployeeDetails () {
      this.axios.get('/api/employee/' + this.currentUser.Employee_ID, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.employeeFullInfo = res.data[0]
        this.showPolicyDialog = true
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    deletePolicy () {
      this.axios.post('/api/employee_delete_policy', { policyId: this.policyIdToRemove }, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(() => {
        this.$store.dispatch('removePolicy', { policyId: this.policyIdToRemove })
        this.$store.dispatch('setSuccess', { successMsg: 'Successfully deleted' })
        this.policyIdToRemove = null
        this.deletePolicyDialog = false
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error })
      })
    },
    getUsers () {
      this.axios.get('/api/employee_policy_users', {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(result => {
        this.$store.dispatch('setPolicyUsers', { policyUsers: result.data })
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error })
      })
    },
    updatePolicyUserCount (val) {
      const pu = this.policyUsers.find(item => item.Employee_ID === val.employeeId)
      pu.Agreed += val.value
    }
  }
}
</script>
